const ExpandableDescription = ({ text, className = "", maxLines = 2 }) => {
  if (!text) return null;

  return (
    <span
      className={`text-sm 3xl:text-sm font-normal text-white/90 leading-relaxed ${className}`}
      style={{
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        lineHeight: "1.5",
      }}
      title={text}
    >
      {text}
    </span>
  );
};

export default ExpandableDescription;
